module.exports = __webpack_public_path__ + "static/Lark Technologies-fd2c9d7686e038cb25e709b6a1df0b73.jpg";